 namespace('arctic.views.common');


compass.require('compass.hotel.HotelListWidget');
compass.require('compass.hotel.HotelFilterWidget');
compass.require('compass.hotel.SimplifiedHotelFilterWidget');
compass.require('compass.hotel.FilterBreadcrumbWidget');
compass.require('compass.map.BigMapWidget');
compass.require('compass.map.MapboxWidget');
compass.require('compass.hotel.HotelInventoryMatrixPopupWidget');
compass.require('compass.hotel.PriceSavingsExplanationWidget');
compass.requireLib('compass.util.format');

arctic.views.common.hotels = function(viewport, data) {

    //Quick non-obvious architecture note on filters from a new guy who just took way too long to grok it.
    //
    //There is one FilterWidget (two types, but only one active per meeting) that draws the panel with the
    //various filter controls and emits events that tell you all the active filters and their values.
    //
    //There is also HotelFilter.js which deals with the problem of having two simultaneously existing
    //widgets (map and hotelList) that draw things differently depending on what's been filtered.
    //These widgets each get their own instance of HotelFilter which has a bunch of methods passed in
    //for it to use as it iterates over the elements it determines are filtered or unfiltered for doing
    //things like sorting/redrawing elements, etc... 
    //
    //If you need to know what's been filtered, check the _hotelsFiltered var. It updates automatically.
    //If you need live data via an event, see the binding to 'hotelsFiltered' on _viewport.


    // starts measuring the time it takes for the view to load
    compass.startLoad('hotelsView');

    var _viewData = data;
    var _viewport = viewport;
    var _availData;
    var _dateMask = data.meetingInfo.datemask;
    var _matrixData;

    var _promotions;
    var _hotels;
    var _hotelsFiltered;
    var _customGalleryCards;
    var _availMin = 0; //set via event to be whatever current filter number of hotels filter value is
    var _availActive = false;
    var _availCallbacks = []; //for putting off an action until an avail call has completed
    var _inventoryMatrixCallbackQueued = false;

    var _category;
    var _meetingInfo = _viewData.meetingInfo;
    var _displayPromoFilter = false;
    var _displayHotelStars = true;
    var _showSoldOutHotels = true;
    var _requireCheckInOutDates = _meetingInfo.requireCheckInOutDates;
    var _hideDistance = false;
    var _hideNumberOfRoomsAvailable = false;
    var _showSimplifiedFilter = _meetingInfo.showSimplifiedHotelFilter === true;

    var _filterWidget;
    var _filterBreadcrumbWidget;
    var _gridListWidget;
    var _someMapWidget;
    var _someMapWidgetClassName = '.BigMapWidget';
    var _ginAlertDialog;
    var _imAlertDialog;
    var _inventoryMatrixPopup;
    var default_sort_distance = false;
    var explicitSort = false;
    var d = jQuery.dom;
    
    var _autoCurtain = _viewData.noAutoCurtain === '1' ? false : true;
    
    var _customGalleryCardsAjaxDone = false;
    var _availAjaxDone = false;

    var SOLD_OUT_STATUS = 'SOLDOUT';/* just a constant */

    //need to track avail call activity to avoid use of old data while filters are calling/redrawing
    $('body').bind('availDataChange', function(e){
        _availData = e.availData;
        _availActive = false;
        
        while(_availCallbacks.length){ _availCallbacks.pop()(); }
        _inventoryMatrixCallbackQueued = false; 
        
    } );
    $('body').bind('availActive', function(){ _availActive = true; } );
    
    // Waits for both ajax calls to be completed before drawing the HotelListWidget
    function waitForAjaxComplete(renderComplete) {
        if (_customGalleryCardsAjaxDone && _availAjaxDone) {
            _viewport.append(_drawHotels());
            // trigger the event to let godview know that a view has loaded and return a string that can be prepended to the header widget
            // for better screen reading of the page
            _viewport.add(compass).trigger(CompassEvents.ViewLoaded, 'Hotel Gallery – Filter and search available properties to select hotel for reservation');
            // stops measuring the time it takes the view to load
            while(_availCallbacks.length){ _availCallbacks.pop()(); }
            _inventoryMatrixCallbackQueued = false;
            compass.stopLoad('hotelsView');

            var _availableHotels = _hotels;
            if (_showSoldOutHotels === false) {
                _availableHotels  = _.filter(_hotels, function(hotel) {
                    return hotel.avail.status !== SOLD_OUT_STATUS;
                });
            }
            
            if (_availableHotels.length === 1 && _availableHotels[0].avail.status !== SOLD_OUT_STATUS && _autoCurtain) {
            	_viewport.trigger(CompassEvents.Navigate, 'hotelInfo/' + _availableHotels[0].hotelId);
                return;
            }
            renderComplete();
        }
    }

    this.run = function(renderComplete) {
        compass.loading.start();

        var defaultDates = {};
        // if DefaultFilterDatesToBlank is false, then default dates to the standard dates
        // we need this because this first avail call will need to match what's visuall in the inputs which will be the standard dates
        if ( _viewData.arrive ){
            defaultDates = {
                    'arrive': _viewData.arrive,
                    'depart': _viewData.depart
                };
        }
        else if(!_meetingInfo.entryDatesDefaultToBlank){
            defaultDates = {
                'arrive': _meetingInfo.dayBeforeStarts,
                'depart': _meetingInfo.ends
            };
        }
        if(_meetingInfo.showCustomGalleryCards) {
            jQuery.ajax({
                url : '/getCustomGalleryCards',
                dataType: 'json',
    			ignoreTimeout : true,
                success: function(customGalleryCards) {
                    _customGalleryCards = customGalleryCards;
                },
                error: function(error) {
                    _customGalleryCards = [];
                },
                complete: function() {
                    _customGalleryCardsAjaxDone = true;
                    waitForAjaxComplete(renderComplete);
                }
            });
        } else {
            _customGalleryCardsAjaxDone = true;
        }
        
        $('body').trigger('availActive');
        jQuery.ajax( {
            url : '/avail',
            data: defaultDates,
            dataType: 'json',
            success: function(availData) {
                compass.loading.stop();
				
				if ( availData.sendToEntry && availData.sendToEntry === true ){
					_viewport.trigger(CompassEvents.Navigate, 'entry');
					return;
				}

				explicitSort = $.grep(availData.hotels, function (item) {
					return item.sortOrder !== "";
				});
				explicitSort = explicitSort.length === 1 ? true : false;
				default_sort_distance = availData.defaultDistanceSort === "Y" ? true : false;
                // avail gets called with category permissions but godview does not, so replace the value of groupsEnabled 
                _availData = availData;
                _availActive = false;
                _refreshMeetingInfoValues(availData);
                _hotels = availData.hotels;
                _nights = availData.nights;
                _category = availData.category_name;
                _showSoldOutHotels = availData.showSoldOutHotels;
                _displayPromoFilter = availData.displayPromoFilter;

                _defaultFilterDatesToBlank = _viewData.arrive ? false : availData.DefaultFilterDatesToBlank;
                _displayHotelStars = availData.displayHotelStars;
                _hideDistance = availData.hideDistance;
                _hideNumberOfRoomsAvailable = availData.hideNumberOfRoomsAvailable;

                _availAjaxDone = true;
                waitForAjaxComplete(renderComplete);
            }
        } );

    };

    function _refreshMeetingInfoValues(availData){
        _meetingInfo.groupsEnabled = availData.groupsEnabled;
    }

    var _arePromisesSupported = function() {
        try {
            /*
            We don't actually care what the promise does, we just want to check a few things
            - Promise exists and can actually be used to build a promise
            - .then, .catch, .finally are part of the promise prototype
            */
            new Promise(function(resolve, reject) { resolve(); })
                .then(function() { return; })
                .then(function() { return; })
                .catch(function() { return; })
                .finally(function() { return; });
        } catch (err) {
            return false;
        }
        return true;
    };

    var _cardClickHandler = function(evt, data) {
        var isExpediaHotel = data.hotel.avail.affiliates && data.hotel.avail.affiliates[0] === 'EAN';
        var promisesSupported = _arePromisesSupported();
        if (isExpediaHotel === true && promisesSupported === false) {
          window.location = compass.staticPrefix + '/resources/html/updateBrowser.html';
          return;
        }
        var route = 'hotelInfo/' + data.hotel.hotelId;
        
        if (_filterWidget.arrive) {
            route += '/' + _filterWidget.arrive + '/' + _filterWidget.depart;
        }
        if (_filterWidget.occupancy) {
            route += '/' + Math.round(_filterWidget.occupancy);
        }
        _viewport.trigger(CompassEvents.Navigate, route);
    };

    var _customCardClickHandler = function(evt, data) {
      data = _.extend(data, {
        requireCheckInOutDates: _viewData.meetingInfo.requireCheckInOutDates
      });
      jQuery.ajax({
        url : '/sendToKeen',
        type: 'POST',
		ignoreTimeout : true,
        data: JSON.stringify({ 'stream': 'compass_gallery_customCardClick', eventData: data }),
        dataType: 'json',
        error: function(event) {} //If call fails, suppress
      });
    };

    function _getInventoryMatrixInfo(dataReadyHandler){

        compass.loading.start();

        var _availFiltered = [];

        for(var x in _hotelsFiltered){
            var thisHotel = _hotelsFiltered[x];
            if(thisHotel.avail){ _availFiltered.push(x); }
        }

        jQuery.ajax({
            url : '/inventoryMatrixInfo',
            data: {},
            dataType: 'json',
            success: function(data) {
            	data.localization = {
                    currencySymbol:_meetingInfo.currencySymbol
                };

                /*sometimes night data does not come back when all hotels available are gds hotels, so we set the dates to an empty array */
                if(data.blockAvail.length){
                    data.dates = _.map( data.blockAvail[0].nights, function(night){
                        return night.date;
                    } );
                }
                else {
                    data.dates = [];
                }

                //note:lots of other properties we could attach to hotels here for sorting potential
                var hotelProperties = {}; //name map to properties: distance
                _.each( _availData.hotels, function(hotel){
                    hotelProperties[hotel.hotelId] = {
                        status: hotel.avail.status,
                        maxAllowed: hotel.avail.maxAllowed,
                        isAvailable: availCheck(hotel),
                        distance: hotel.distance,
                        distanceUnit: hotel.distanceUnits,
                        hqHotel: hotel.hqHotel,
												sortOrder: hotel.sortOrder
                    };
                } );
                var gdsHotels = _.filter(_availData.hotels, function(hotel){ return ( (hotel.avail.status === 'GDS') || (hotel.avail.affiliates !== undefined && hotel.avail.affiliates[0] === 'EAN') ); });
                _.each(gdsHotels, function(gdsHotel) {
                    var gdsBlock = gdsHotel;
                    gdsBlock.gdsRate = (gdsHotel.avail.lowestAvgRateNumeric < 1) ? 'TBD' : (_meetingInfo.currencySymbol + gdsHotel.avail.lowestAvgRateNumeric.toFixed(0));
                    gdsBlock.hotelName = gdsBlock.name;
                    gdsBlock.blockName = '';
                    gdsBlock.meetingHotelId = '';
										gdsBlock.lowestAvgRate = 'GDS';
                    if (gdsBlock.avail.affiliates && gdsBlock.avail.affiliates[0] === 'EAN') {
                      // Even if an EPS hotel isn't available, we still want it to display as TBD. 'forceDisplay' is used 
                      // to bypass filters that would otherwise prevent an unavailable hotel from displaying in the matrix
                      gdsBlock.forceDisplay = true;
                    }
                    data.blockAvail.push(gdsBlock);
                });
                
                // all hotels are permissioned and no gds properites got put up a message.
                if (data.blockAvail.length === 0 ){

                    var imAlert_container = d.div(
                            {className: 'imAlertWrapper'}, 
                            d.h2({}, 'No hotels available.' ),
                            d.div({className: 'imAlertText'},
                                'No availability information to show. Please try a different set of filters.'
                            )
                        );
                        
                        _imAlertDialog = d.dialog({
                            contents: imAlert_container,
                            centerOnView: true
                        });
                	
                	compass.loading.stop();
                	_availActive = true;
                	return;
                }
                
				// get current arrive/depart/occupancy from hotelFilter
				var _peakNight = compass.util.parse.ISODateParser(_meetingInfo.peakNight);
				var _dayAfterPeakNight = new Date(_peakNight.getTime());
				_dayAfterPeakNight.setDate(_peakNight.getDate() + 1);

				var _arrive = _filterWidget.arrive ? compass.util.parse.ISODateParser(_filterWidget.arrive) : _peakNight;
				var _depart = _filterWidget.depart ? compass.util.parse.ISODateParser(_filterWidget.depart) : _dayAfterPeakNight;
				var _occupancy = _filterWidget.occupancy || 1;
				var _nightsStay = _.filter(data.dates, function(date) {
					var _date = compass.util.parse.ISODateParser(date);
					return _arrive <= _date && _date < _depart;
				});

                _.each( data.blockAvail, function(block){
                    var props = hotelProperties[block.hotelId];

					var availableRoomTypes = _.filter(block.roomTypes, function(roomType) {
						return !_filterWidget.arrive || roomType.MinimumNights <= _nightsStay.length;
					});

					var availableRoomTypeRates = _.map(availableRoomTypes.length ? availableRoomTypes : block.roomTypes, function(roomType) {
						var nights = _.filter(roomType.Nights, function(night) {
							var _date = compass.util.parse.ISODateParser(night.date);
							return _arrive <= _date && _date < _depart;
						});

						var _roomTypeAvgRate = _.reduce(nights, function(sum, night) { return sum + night.rate; }, 0) / nights.length;
						return { blockedRoomId: roomType.BlockedRoomID, avgRate: Math.round(_roomTypeAvgRate) };
					});

					var _roomTypeLowestRate = _.min(availableRoomTypeRates, function(roomType) { return roomType.avgRate; });

					var minNights;
					if(_filterWidget.arrive) {
						var blockMinimumNights = _.min(block.roomTypes, function(roomType) { return roomType.MinimumNights; });
						minNights = blockMinimumNights.MinimumNights <= _nightsStay.length;
					} else {
						minNights = true;
					}

                    if(props){
                        block.status = props.status;
                        block.maxAllowed = props.maxAllowed;
                        block.lowestAvgRate = block.lowestAvgRate === 'GDS' ? block.lowestAvgRate : _roomTypeLowestRate.avgRate;
												block.lowestRateBlockedRoomId = _roomTypeLowestRate.blockedRoomId;
                        block.isAvailable = props.isAvailable;
                        block.distance = props.distance;
                        block.distanceUnit = props.distanceUnit;
                        block.hqHotel = props.hqHotel;
												block.sortOrder = props.sortOrder;
                    }

					// sort out unavailable blocks within available, non-GDS hotels
					if(block.lowestAvgRate != 'GDS') {
						var nights = _.filter(block.nights, function(night) {
							var _date = compass.util.parse.ISODateParser(night.date);
							return _arrive <= _date && _date < _depart;
						});


						var allNightsHaveAvailability = _.every(nights, function(night) {
							return night.rooms >= _occupancy;
						});

						var arriveIsAllowed = (nights && nights.length > 0 && nights[0].noArrive === false);

						var departDateString = compass.util.dateFormatter('yyyy-mm-dd')(_depart);
						var departNight = _.find(block.nights, function(night) {
							return night.date === departDateString;
						});
						var departIsAllowed = ((departNight ? departNight.noDepart : false ) === false);
						
						block.isAvailable = allNightsHaveAvailability && arriveIsAllowed && departIsAllowed && minNights;
					}
                });

                _matrixData = new InventoryMatrixData(data);

                compass.loading.stop();

                dataReadyHandler();
            }
        });
        //lifted/modified from avFilt and getAvailability in HotelFilter but with the bool return vals reversed
        function availCheck(hotel) {

            if( _.contains( _availFiltered, String(hotel.hotelId) ) ) {
                return false;
            }

            if( (hotel.avail.status === 'GDS' && _availMin !== 0) || hotel.avail.status === 'SOLDOUT'){
                return false;
            } else {
                return true;
            }
            
        }

        function InventoryMatrixData(data){

            var colToRowNameMap = {
                '0':'hotelName',
                '1':'distance',
                '2':'lowestAvgRate'
            };

            var _startDate = this.startDate = _filterWidget.arrive || '';
            var _endDate = this.endDate = _filterWidget.depart || '';

            var _startIndex = _.indexOf( data.dates, _startDate || _meetingInfo.starts );
            var _endIndex = _.indexOf( data.dates, _endDate || _meetingInfo.ends ) - 1;

            this.startIndex = _startIndex;
            this.dateRange = _endIndex - _startIndex;

            var isEnd = data.dates[_endIndex] ? true : false;

            // initial sort
            sortBy('default');

            this.localization = data.localization;

            this.totalAvailCount = function(){
                var availObj = _.countBy( data.blockAvail, function(el){ return (el.isAvailable || el.forceDisplay) ? 'available' : 'unavailable'; } );

                if( availObj.available === undefined && availObj.unavailable !== undefined){
                    availObj.available = 0;
                }
                return availObj.available;
            };
            
            this.mapCols = function(index){
                return colToRowNameMap[index];
            };
            
            this.sortBy = sortBy;

            function sortBy(property, ascending){

                function defaultNumericSort(aProp, bProp, ascending) {
                  if(aProp === bProp) {
                    return 0;
                  } else if(aProp < bProp) {
                    return ascending ? -1 : 1;
                  } else {
                    return ascending ? 1 : -1;
                  }
                }

                function hotelNameSort(a, b, ascending) {
									var hotelNameA = a.hotelName.toLowerCase();
									var hotelNameB = b.hotelName.toLowerCase();
                  if(hotelNameA === hotelNameB) {
										var blockNameA = a.blockName.toLowerCase();
										var blockNameB = b.blockName.toLowerCase();
                    return defaultNumericSort(blockNameA, blockNameB, ascending);
                  } else {
                   return defaultNumericSort(hotelNameA, hotelNameB, ascending);
                  }
                }

                function distanceSort(a, b, ascending) {
                  var ascendToggle = ascending ? 1 : -1;

                  //sort by distance then price if applicable 
                  if (a.distanceUnit === b.distanceUnit) {
                    return (a.distance - b.distance) * ascendToggle;

                  //distance units priority: blocks < miles < everything else
                  } else if (a.distanceUnit === 'Blocks' || b.distanceUnit === 'Blocks') {
                    return ascendToggle * (a.distanceUnit === 'Blocks' ? -1 : 1);
                  } else if (a.distanceUnit === 'Miles' || b.distanceUnit === 'Miles') {
                    return ascendToggle * (a.distanceUnit === 'Miles' ? -1 : 1);
                  } else {
                    return 0;
                  }
                }

                function avgRateSort(a, b, ascending) {
                  if(a.lowestAvgRate === 'GDS' || b.lowestAvgRate === 'GDS') {
                    if(a.lowestAvgRate === 'GDS' && b.lowestAvgRate === 'GDS') {
                      return 0;
                    } else {
                      return a.lowestAvgRate === 'GDS' ? 1 : -1;
                    }
                  } else {
                    return defaultNumericSort(a.lowestAvgRate, b.lowestAvgRate, ascending);
                  }
                }

                if(typeof ascending === 'undefined'){ ascending = true; }

                data.blockAvail.sort( function(a,b) {
                    if(a.isAvailable === b.isAvailable){

                        if(property === 'default') {
														if(a.sortOrder || b.sortOrder) {
															return defaultNumericSort(a.sortOrder, b.sortOrder);
														} else if(a.hqHotel || b.hqHotel) {
                              if(a.hqHotel === b.hqHotel) {
                                return hotelNameSort(a, b, ascending);
                              } else {
                                return a.hqHotel ? -1 : 1;
                              }
                            } else {
                              return hotelNameSort(a, b, ascending);
                            }
                        } else if(property === 'hotelName') {
                            return hotelNameSort(a, b, ascending);
                        } else if(property === 'distance') {
                            return distanceSort(a, b, ascending);
                        } else if(property === 'lowestAvgRate') {
                            return avgRateSort(a, b, ascending);
												} else {
                            return defaultNumericSort(a[property], b[property], ascending);
                        }

                    } else {
                        return a.isAvailable ? -1 : 1;
                    }
                } );
                
                return this;
            }

            this.as2DArray = as2DArray;

            function as2DArray(){
                
                var headerCols;
                var table = _.map( data.blockAvail, function(el){
                        var row = [
                            [el.hotelName, el.blockName],
                            [el.distance, el.distanceUnit],
                            el.lowestAvgRate
                        ];
                        
                        headerCols = (['Hotel Rooms/Room Blocks', 'Distance', ['Avg/Nightly', 'Event Rate'] ]).concat( data.dates );

                        //assigning properties to arrays here
                        //so we can sort on the properties but separate them
                        //from content intended for dom building
                        row.hotelId = el.hotelId;
                        row.blockId = el.blockId;
												row.blockedRoomId = el.lowestRateBlockedRoomId;
                        row.isAvailable = el.isAvailable;

                        if(el.status === 'GDS' || el.forceDisplay) {
                          row.overrideFormatter = 'gds';
                          row.gdsRate = el.gdsRate;
                        } else {
                          _.each( el.nights, function(night){
                              var availCount = ( parseInt(night.rooms) < el.maxAllowed ) ? night.rooms : el.maxAllowed;
                              row.push( availCount );
                          } );
                        }


                        if( _.find( _availFiltered, function(el){ return el == row.hotelId; } ) ){
                            row.isAvailable = false;
                        }

                        return row;
                    } )
                ;

                table = _.filter(table, function(el){ return el !== false; } );

                table.unshift( headerCols );

                return table;
            }

        }

    }

    // GridList / HotelList widget holds all of the Hotel Cards
    function createGridListWidget() {
        var gridWrapper = d.div({ className : 'mapOrGridWrapper', role : 'main', 'ARIA-role' : 'main'});
        _gridListWidget = new compass.hotel.HotelListWidget(gridWrapper, {
            WUID : 'HotelListWidget',
            hotels : _hotels,
            customGalleryCards : _customGalleryCards,
            meetingInfo : _meetingInfo,
            displayHotelStars : _displayHotelStars,
            showSoldOutHotels : _showSoldOutHotels,
            showSimplifiedFilter : _showSimplifiedFilter,
            requireCheckInOutDates : _requireCheckInOutDates,
            default_sort_distance : default_sort_distance,
            explicitSort : explicitSort,
            hideDistance : _hideDistance,
            hideNumberOfRoomsAvailable : _hideNumberOfRoomsAvailable,
            displayPriceSavings: _meetingInfo.displayPriceSavings
        });
        _gridListWidget.bind("HotelCard.hotelClicked", _cardClickHandler);
        _gridListWidget.bind("CustomCard.clicked", _customCardClickHandler);
        _gridListWidget.trigger('dataChanged');

        return {
            wrapper : gridWrapper,
            widget  : _gridListWidget
        };
    }

    // Map Widget shows the meeting map with hotels / POI displayed
    function createMapWidget(gridWrapper) {
        // set the data from the initial /avail call into the big map widget
        // any subsequent updates to availability are handled through hotelFilter.redraw() function passed into it
        // as opposed to the way it was done before, which was done when clicking hte map button
        var mapOptions = {
            WUID : 'MapWidget',
            meetingInfo : _meetingInfo,
            displayHotelStars : _displayHotelStars,
            displayPriceSavings: _meetingInfo.displayPriceSavings,
            hotels : _hotels,
            hideDistance : _hideDistance,
            hideNumberOfRoomsAvailable : _hideNumberOfRoomsAvailable
        };

        if (_meetingInfo.enableMapbox) {
          _someMapWidget = new compass.map.MapboxWidget(gridWrapper, mapOptions);
          _someMapWidgetClassName = '.MapboxWidget';
        } else {
            _someMapWidget = new compass.map.BigMapWidget(gridWrapper, mapOptions);
        }

        _someMapWidget.bind("HotelCard.hotelClicked", _cardClickHandler);
        gridWrapper.find(_someMapWidgetClassName).hide();

        return {
            wrapper : gridWrapper,
            widget  : _someMapWidget
        };
    }

    function createInventoryMatrix(_filterWidget) {
        //binding to hotelFilter changes because hotelFilter has multiple instances
        //It would hurt nothing to move this out of the if condition for use by other stuff.
        $('#viewport').bind('hotelsFiltered', function(e) {
            _hotelsFiltered = e.hotelsFiltered;
            _availMin = e.availMin || 0;
        });

        var nightlyAvailabilityBtnHandler = function() {
            if(!_availActive){
                _availActive = true;
                showPopup();
            } else if(!_inventoryMatrixCallbackQueued){
                _inventoryMatrixCallbackQueued = true;
                _availCallbacks.unshift(showPopup);
            }
        };
        _filterWidget.bind('HotelFilterWidget.showNightlyAvailabilityPopup', nightlyAvailabilityBtnHandler);

        var showPopup = function() {
            _getInventoryMatrixInfo(function() {
                _inventoryMatrixPopup = new compass.hotel.HotelInventoryMatrixPopupWidget(
                    d.div({ className: 'HotelInventoryMatrixPopupWidget'}),
                    {
                        hotelsFiltered:_hotelsFiltered,
                        dateRange:[_filterWidget.arrive, _filterWidget.depart],
                        matrixData:_matrixData,
                        roomsRequested:_availMin,
                        shortDateFormatter: _viewData.meetingInfo.defaultShortDateFormatter
                    }
                );
                _availActive = false;
            });
        };
    }

    // Filter Widget (Old) shows options for filtering hotel selection, prices in date range, etc...
    function createFilterWidget(gridWrapper) {
        var filterWrapper = d.div({ className : 'filterWrapper', role : 'complimentary', 'ARIA-role' : 'complimentary' });
        filterWrapper.append(d.a({ className : 'toggleFilterLink' },
            d.span({ className : 'filter-icon-stack', role: 'button', 'ARIA-role' : 'button', 'ARIA-label' : 'show filter', tabindex: 0 },
            		d.i({ className : 'fa-regular fa-circle-plus'}),
            		d.span('Filter &amp; Sort')
            )
        ).activate(function(event) {
            $(this).find('.fa-circle-minus,.fa-circle-plus').toggleClass('fa-circle-minus fa-circle-plus');
            _filterWidget.getWidgetElem().toggleClass('visible');
        }));

        if (_meetingInfo.displayPriceSavings) {
          var priceSavingsExplanationLinkWrapper = d.span({className: 'priceSavingsExplanationLinkWrapperLowWidth'}, 
            d.span({className: 'priceSavingsIcon'}, d.i({className:'fa-usd'})),
            d.span({className: 'priceSavingsExplanationLink'}, "How rate comparison is calculated")
          );
          priceSavingsExplanationLinkWrapper.activate(function(e) {
            compass.GA.trackEvent('Additional Information', 'Rate Comparison Description', 'Hotel Gallery');
            priceSavingsDialog = new compass.hotel.PriceSavingsExplanationWidget(null, {
              priceSavingsPercent: _meetingInfo.priceSavingsPercent
            });
          });
          
          filterWrapper.append(priceSavingsExplanationLinkWrapper);
        }

        _filterWidget = new compass.hotel.HotelFilterWidget(filterWrapper, {
            WUID : 'crap',
            meetingInfo : _meetingInfo,
            displayHotelStars : _displayHotelStars,
            hideDistance : _hideDistance,
            hotels : _hotels,
            category : _category,
            nightsArray : _nights.NIGHTS,
            dateFormat: _meetingInfo.datemask,
            requireCheckInOutDates : _requireCheckInOutDates,
            defaultFilterDatesToBlank : _defaultFilterDatesToBlank,
            default_sort_distance : default_sort_distance,
            explicitSort : explicitSort,
            showInventoryMatrix : _availData.showInventoryMatrix,
            displayPriceSavings: _meetingInfo.displayPriceSavings
        });

        if (_availData.showInventoryMatrix){
            createInventoryMatrix(_filterWidget);
        }

        return {
            wrapper : filterWrapper,
            widget  : _filterWidget
        };
    }

    // SimplifiedFilter Widget is also for hotel filtering but is newer & displays at the top instead of the side
    function createSimplifiedFilterWidget(gridWrapper) {
        var filterWrapper = d.div({ className : 'simplifiedFilterWrapper', role : 'complimentary', 'ARIA-role' : 'complimentary' });
        _filterWidget = new compass.hotel.SimplifiedHotelFilterWidget(filterWrapper, {
            WUID : 'SimplifiedHotelFilterWidget',
            meetingInfo : _meetingInfo,
            category : _category,
            displayHotelStars : _displayHotelStars,
            displayPromoFilter : _displayPromoFilter,
            hotels : _hotels,
            displayPriceSavings: _meetingInfo.displayPriceSavings,
            showInventoryMatrix: _availData.showInventoryMatrix,
            nightsArray : _nights.NIGHTS,
            dateFormat  : _meetingInfo.datemask,
            defaultFilterDatesToBlank : _defaultFilterDatesToBlank,
            defaultSortDistance : default_sort_distance,
            initialFilters: _availData.initialFilters || {},
            promotions: _availData.promotions,
            onPeakPromotionTypes: _availData.onPeakPromotionTypes,
            displayAISearch: _availData.displayAISearch
        });

        if (_availData.showInventoryMatrix){
            createInventoryMatrix(_filterWidget);
        }

        return {
            wrapper : filterWrapper,
            widget  : _filterWidget
        };
    }

    // Bind common actions shared by the old & new filter widgets
    function bindFilterWidgetActions(widget, gridWrapper) {
        // Group sub-block contract alert
        widget.bind('HotelFilterWidget.ginAlert', function() {
            var ginAlert_container = d.div(
                {className: 'ginAlertWrapper'}, 
                d.h2({}, 'Group Sub-Block Contract Required' ),
                d.div({className: 'ginAlertText'},
                    'Booking a group of ' + _availData.GINThreshold + ' or more rooms requires agreement to a group sub-block contract before completion of booking.'
                ),
                d.div({className: 'secondaryButton', onclick : function() {_ginAlertDialog.close();}}, 'OK')
            );
            
            _ginAlertDialog = d.dialog({
                contents: ginAlert_container,
                centerOnView: true
            });
        });
        // 'Data changed' event, causes all widgets to update with new data
        widget.bind('HotelFilterWidget.dataChanged', function(evt, data) {
            if (_filterBreadcrumbWidget) {
                _filterBreadcrumbWidget.updateFilter(data);
            }
            _gridListWidget.updateFilter(data);
            _someMapWidget.updateFilter(data);
        });
        // "Display Grid" action
        widget.bind('HotelFilterWidget.gridViewClicked', function(evt) {
            gridWrapper.find('.HotelListWidget').show();
            gridWrapper.find(_someMapWidgetClassName).hide();
            _gridListWidget.updateFilter();
            compass.trackPageView('GalleryView', {
                 src : 'arctic.views.common.entryPage',
                 automatic : false
            });
        });
        // "Display Map" action
        widget.bind('HotelFilterWidget.mapViewClicked', function(evt) {
            gridWrapper.find('.HotelListWidget').hide();
            _someMapWidget.draw(); // need this for the first time to initiate google map call
            compass.trackPageView('MapView', {
                 src : 'arctic.views.common.entryPage',
                 automatic : false
            });
        });
    }

    // Creates all the widgets, binds functionality, & draws them to the view
    function _drawHotels() {
        // Create various widgets for hotel selection
        // These functions returns wrappers & widgets, but most/all of the widgets are defined in
        //   scope of the entire hotels.js view object, such as _filterWidget & can be referenced
        //   directly by name.
        var gridListWidgetObject = createGridListWidget();
        var gridWrapper          = gridListWidgetObject.wrapper;
        var mapWidgetObject      = createMapWidget(gridWrapper);
        var breadcrumbWrapper    = {};
        var filterWidgetObject;
        if (_showSimplifiedFilter) {
            filterWidgetObject = createSimplifiedFilterWidget(gridWrapper);
        } else {
            filterWidgetObject = createFilterWidget(gridWrapper);
            breadcrumbWrapper = d.div({ className : 'breadcrumbWrapper' });
            _filterBreadcrumbWidget = new compass.hotel.FilterBreadcrumbWidget(breadcrumbWrapper, {
                WUID : 'filterBreadcrumbWidget_entryPage'
            });
            _filterBreadcrumbWidget.bind('FilterBreadcrumbWidget.closeBreadcrumb', function(evt, key) {
                _filterWidget.unsetFilter(key);
                _gridListWidget.unsetFilter(key);
            });
        }
        bindFilterWidgetActions(filterWidgetObject.widget, gridWrapper);

        $('body').one('shutupwesley', function(e) {
            var head = document.getElementsByTagName("head")[0];
            var script = document.createElement("script");
            script.src = compass.staticPrefix + '/resources/js/core/cornify.js';

            // Handle Script loading
            var done = false;

            // Attach handlers for all browsers
            script.onload = script.onreadystatechange = function(){
                if (!done && (!this.readyState || this.readyState == "loaded" || this.readyState == "complete")) {
                    done = true;
                    $('body').click(cornify_add);
                    // Handle memory leak in IE
                    script.onload = script.onreadystatechange = null;
                }
            };
            head.appendChild(script);

            // We handle everything using the script element injection
            return undefined;
        });

        return d.div({ className : 'hotels' },
            breadcrumbWrapper,
            d.div({ className : 'filterMapGridWrapper' },
                filterWidgetObject.wrapper,
                gridWrapper
            )
        );
    }

};

